document.addEventListener('click', function (event) {
	if (event.target.closest('.cart-toggle') || event.target.closest('.ajax-cart-overlay')) {
    event.preventDefault();
    document.querySelector('.ajax-cart').classList.toggle('open');
  }
  return;
}, false);

function updateCart (cart, cart2) {
  toggleCartLoader();
  var formData = [];
  for (let index = 0; index < cart.elements.length; index++) {
    const element = cart.elements[index];
    if (element.name == 'updates[]') {
      formData.push(parseInt(element.value));
    }
  }
  formDataJSON = {
    updates: formData
  };
  console.log(JSON.stringify(formDataJSON));
  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formDataJSON),
  }).then(function(){
    fetch('/cart?view=ajax').then(function (response) {
      return response.text();
    }).then(function (html) {
      var parser = new DOMParser();
      var cartHTML = parser.parseFromString(html, 'text/html');
      cart.innerHTML = cartHTML.querySelector('body').innerHTML;
      if (cart2) {
        cart2.innerHTML = cartHTML.querySelector('body').innerHTML;
      }
      var bubbles = document.querySelectorAll('.cart-bubble');
      if (cartHTML.querySelector('#cart-count')) {
        var cart_count = cartHTML.querySelector('#cart-count').innerHTML;
        for (var i = 0; i < bubbles.length; i++) {
          bubbles[i].innerHTML = cart_count;
          if (cart_count > 0) {
            bubbles[i].classList.remove('sr-only');
          } else {
            bubbles[i].classList.add('sr-only');
          }
        }
      } else {
        for (var i = 0; i < bubbles.length; i++) {
          bubbles[i].classList.add('sr-only');
        }
      }
      bindQuantityFields();
      cartUpsellSlider();
      toggleCartLoader();
    }).catch(function (error) {
      console.warn('Something went wrong.', error);
    });
  })
  .catch(function(error) { 
    console.warn('Something went wrong.', error);
  });
}

function toggleCartLoader() {
  var el = document.querySelector('.cart-loader');
  if (el.style.display == "none") {
    el.style.display = "flex";
  } else {
    el.style.display = "none";
  }
}

function addProductToCart(e) {
  e.preventDefault();
  toggleCartLoader();
  let addToCartForm = e.target;
  let formData = new FormData(addToCartForm);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  }).then(function(){
    if (document.getElementById('to-name')) { // Gift messaging enabled
      var to = document.getElementById('to-name').value;
      var from = document.getElementById('from-name').value;
      var email = document.getElementById('gift-email').value;
      var message = document.getElementById('gift-message').value;
      if (message != '') {
        console.log(message);
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "note": "Lucky you "+ to +", "+ from +" sent you this great gift. "+ message,
            "attributes": {
              "Gift to": to,
              "Gift from": from,
              "Gift email": email,
              "Gift message": message
            }
          })
        }).catch((error) => {
          console.error('Error:', error);
        });
      }
    }
  }).then(function(){
    refreshCart();
  }).catch((error) => {
    console.error('Error:', error);
  });
}

function refreshCart() {
  fetch('/cart?view=ajax').then(function (response) {
    return response.text();
  }).then(function (html) {
    var parser = new DOMParser();
    var cartHTML = parser.parseFromString(html, 'text/html');
    var cart = document.querySelector('#cart-main');
    var cart_ajax = document.querySelector('#cart-main-ajax');
    if (cart) {
      cart.innerHTML = cartHTML.querySelector('body').innerHTML;
    }
    cart_ajax.innerHTML = cartHTML.querySelector('body').innerHTML;
    var bubbles = document.querySelectorAll('.cart-bubble');
    if (cartHTML.querySelector('#cart-count')) {
      var cart_count = cartHTML.querySelector('#cart-count').innerHTML;
      for (var i = 0; i < bubbles.length; i++) {
        bubbles[i].innerHTML = cart_count;
        if (cart_count > 0) {
          bubbles[i].classList.remove('sr-only');
        } else {
          bubbles[i].classList.add('sr-only');
        }
      }
    } else {
      for (var i = 0; i < bubbles.length; i++) {
        bubbles[i].classList.add('sr-only');
      }
    }
    bindQuantityFields();
    cartUpsellSlider();
  }).catch(function (error) {
    console.warn('Something went wrong.', error);
  });
  document.querySelector('.ajax-cart').classList.toggle('open');
  toggleCartLoader();
}

function bindQuantityFields() {
  Array.prototype.slice.call(document.querySelectorAll('.quantity-container')).map(function (container) {
    return {
      input: container.querySelector('.quantity-amount'),
      decrease: container.querySelector('.quantity-decrease'),
      increase: container.querySelector('.quantity-increase'),
      get value () { return parseInt(this.input.value); },
      set value (v) { this.input.value = v; }
    }
  }).forEach(function (item) {
    item.decrease.onclick = function () { 
      item.value -= 1;
      if (item.value < item.input.min) {
        item.value = item.input.min;
      }
      item.input.closest('form').dispatchEvent(new Event('change'));
    };
    item.increase.onclick = function () { 
      item.value += 1;
      if (item.value > item.input.max) {
        item.value = item.input.max;
      }
      item.input.closest('form').dispatchEvent(new Event('change'));
    };
  });
  let addToCartButton = document.querySelectorAll('a.add-to-cart');
  for (let i = 0; i < addToCartButton.length; i++) {
    if (addToCartButton[i]) {
      if (addToCartButton[i].attachEvent) {
        addToCartButton[i].attachEvent("click", ajaxAddToCart);
      } else {
        addToCartButton[i].addEventListener("click", ajaxAddToCart);
      }
    }
  }
  let removeFromCartButton = document.querySelectorAll('a.remove-from-cart');
  for (let i = 0; i < removeFromCartButton.length; i++) {
    if (removeFromCartButton[i]) {
      if (removeFromCartButton[i].attachEvent) {
        removeFromCartButton[i].attachEvent("click", ajaxRemoveFromCart);
      } else {
        removeFromCartButton[i].addEventListener("click", ajaxRemoveFromCart);
      }
    }
  }
}

function bindAddToCartForms() {
	let forms = document.querySelectorAll('form[action$="/cart/add"]');
	[].forEach.call(forms, function(form) {
		if (form) {
			if (form.attachEvent) {
				form.attachEvent("submit", addProductToCart);
			} else {
				form.addEventListener("submit", addProductToCart);
			}
		}
	});
};

function bindSellingPlanWidget() {
  let sellingPlanWidgets = document.querySelectorAll('.selling-plan-widget');
	[].forEach.call(sellingPlanWidgets, function(sellingPlanWidget) {
		if (sellingPlanWidget) {
			var autoDeliveryEl = sellingPlanWidget.querySelector('.auto-delivery-purchase-option');
      var oneTimeEl = sellingPlanWidget.querySelector('.one-time-purchase-option');
      var autoDeliveryFreqEl = sellingPlanWidget.querySelector('.delivery-frequency-wrap');
      var autoDeliveryPriceEl = sellingPlanWidget.querySelector('.subscription-price');
      var oneTimePriceEl = sellingPlanWidget.querySelector('.one-time-price');
      var autoDeliveryOptions = sellingPlanWidget.querySelectorAll(".rc_input");

      autoDeliveryEl.addEventListener('click', function() {
        this.classList.add('active');
        oneTimeEl.classList.remove('active');
        autoDeliveryFreqEl.classList.add('active');
        sellingPlanWidget.querySelector('.rc_input-1').checked = true;
        autoDeliveryPriceEl.style.display = 'block';
        oneTimePriceEl.style.display = 'none';
      });

      oneTimeEl.addEventListener('click', function() {
        this.classList.add('active');
        autoDeliveryEl.classList.remove('active');
        autoDeliveryFreqEl.classList.remove('active');
        autoDeliveryPriceEl.style.display = 'none';
        oneTimePriceEl.style.display = 'block';
        for (var i=0; i < autoDeliveryOptions.length; i++) {
          autoDeliveryOptions[i].checked = false;
        }
      });
		}
	});
}

function cartUpsellSlider() {
  const cart_upsell_swiper = new Swiper('.cart-upsell-slider', {
    loop: true,
    autoplay: false,
    disableOnInteraction: false,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.custom-swiper-next',
      prevEl: '.custom-swiper-prev',
    }
  });
}

function predictive_search() {
  var input = document.querySelector('#q');
  const predictiveSearchSection = document.querySelector('#predictive-results');
  var requestResponse;
  //on keyup, start the countdown
  input.addEventListener('input', debounce((event) => {
    predictiveSearchSection.style.display = 'block';
    predictiveSearchSection.innerHTML = '<div class="mx-auto my-3 text-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>';
    var search_term = input.value;
    if (input.value != '') {
      fetch('/search/suggest?q='+search_term+'&resources[type]=product,collection,article,page&resources[limit]=3&section_id=site-predictive-search').then((response) => {
        requestResponse = response;
        return response.text();
       })
      .then((text) => {
        if (!requestResponse.ok) {
          console.error(requestResponse.status + ': ' + text);
        }
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-site-predictive-search').innerHTML;
        predictiveSearchSection.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        console.error(error);
      });
    } else {
      predictiveSearchSection.style.display = 'none';
    }
  }, 500));
};

function debounce(func, wait, immediate) {
  var timeout;
  return function executedFunction() {
    var context = this;
    var args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

function reveal() {
  var reveals = document.querySelectorAll(".reveal");
  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 20;
    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("active");
    } else {
      reveals[i].classList.remove("active");
    }
  }
  var header = document.querySelector(".site-header");
  if ( header.getBoundingClientRect().top <= 5) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
  document.querySelector(".navbar-toggler").addEventListener('click', function (event) {
    header.classList.add("scrolled");
    return;
  }, false);
}
window.addEventListener("scroll", reveal);

function customSelect () {
  var x, i, j, l, ll, selElmnt, a, b, c;
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /* For each element, create a new DIV that will act as the selected item: */
    a = document.createElement("DIV");
    a.setAttribute("class", "form-select select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /* For each element, create a new DIV that will contain the option list: */
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 0; j < ll; j++) {
      /* For each option in the original select element,
      create a new DIV that will act as an option item: */
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function(e) {
          /* When an item is clicked, update the original select box,
          and the selected item: */
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              console.log(s.options[i].innerHTML + ' = ' + this.innerHTML );
              s.options[i].selected = true;
              var event = new Event("change", {"bubbles": true});
              s.dispatchEvent(event);
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {
      /* When the select box is clicked, close any other select boxes,
      and open/close the current select box: */
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
    });
  }
  /* If the user clicks anywhere outside the select box,
  then close all select boxes: */
  document.addEventListener("click", closeAllSelect);
}
function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

if (document.readyState === 'loading') {
  // document still loading...
  document.addEventListener('DOMContentLoaded', () => {
    reveal();
  });
} else {
  // already loaded, chocs away!
  reveal();
}

window.addEventListener("load", function () {
  bindAddToCartForms();
  bindSellingPlanWidget();
  bindQuantityFields();
  cartUpsellSlider();
  reveal();
  predictive_search();
  customSelect();

  var cart = document.querySelector('#cart-main');
  var cart_ajax = document.querySelector('#cart-main-ajax');
  if (cart) {
    document.querySelector('#cart-main').addEventListener('change', function(event){
      console.log(event);
      if (event.target.name == 'cart-selling-plan' ) {
        console.log('Change Selling plan');
        editSellingPlan(event.target.getAttribute('data-index'), event.target.value); // index and selling plan id
      } else if (event.target.name == 'selling-plan-toggle') {
        console.log('Selling plan toggle');
        if (event.target.checked == true) {
          editSellingPlan(event.target.getAttribute('data-index'), event.target.value);
        } else {
          editSellingPlan(event.target.getAttribute('data-index'), null);
        }
      } else {
        console.log('Regular cart update');
        updateCart(this, cart_ajax);
      }
    });
  }
  if (cart_ajax) {
    document.querySelector('#cart-main-ajax').addEventListener('change', function(event){
      console.log(event);
      if (event.target.name == 'cart-selling-plan' ) {
        console.log('Change Selling plan');
        editSellingPlan(event.target.getAttribute('data-index'), event.target.value); // index and selling plan id
      } else if (event.target.name == 'selling-plan-toggle') {
        console.log('Selling plan toggle');
        if (event.target.checked == true) {
          editSellingPlan(event.target.getAttribute('data-index'), event.target.value);
        } else {
          editSellingPlan(event.target.getAttribute('data-index'), null);
        }
      } else {
        console.log('Regular cart update');
        updateCart(this, cart);
      }
    });
  }

  let addToCartForm = document.querySelector('form[action$="/cart/add"]');
  if (addToCartForm) {
    if (addToCartForm.attachEvent) {
      addToCartForm.attachEvent("submit", addProductToCart);
    } else {
      addToCartForm.addEventListener("submit", addProductToCart);
    }
  }
});

function ajaxAddToCart (e) {
  e.preventDefault();
  toggleCartLoader();
  console.log(e);
  var variant_id = e.target.getAttribute('data-variant');
  console.log(variant_id);
  let formData = {
    items: [{
     'id': variant_id,
     'quantity': 1
     }]
   };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(function(){
    refreshCart();
    document.querySelector('.ajax-cart').classList.add('open');
  }).catch((error) => {
    console.error('Error:', error);
  });
}

function ajaxRemoveFromCart (e) {
  e.preventDefault();
  toggleCartLoader();
  console.log(e);
  var index = e.target.getAttribute('data-index');
  console.log(index);
  fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({'line': index,'quantity': 0})
  }).then(function(){
    refreshCart();
    document.querySelector('.ajax-cart').classList.toggle('open');
  }).catch((error) => {
    console.error('Error:', error);
  });
}

function editSellingPlan (index, selling_plan) {
  console.log('Index:', index);
  console.log('Selected selling plan:', selling_plan);
  toggleCartLoader();
  fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({'line': index, 'selling_plan': selling_plan }),
  }).then(function(){
    console.log('selling plan updated');
    refreshCart();
    document.querySelector('.ajax-cart').classList.toggle('open');
  })
  .catch(function(error) { 
    console.warn('Something went wrong.', error);
  });

}